import axios from 'axios';
import { API_URL } from '../constants';
import { useInterceptor } from './apiUtils';

useInterceptor(axios);

export function getVendorServices(params) {
  return axios({ method: 'get', url: `${API_URL}/vendor_services`, params });
}

export function getVendorServiceDetails(idx) {
  return axios({ method: 'get', url: `${API_URL}/vendor_services/${idx}` });
}

export function setPackageRemarks(id, data) {
  return axios({
    method: 'put',
    url: `${API_URL}/vendor_services/${id}/set_remarks`,
    data: { vendor_service: data }
  });
}

export function markCompleteVendorService(idx) {
  return axios({
    method: 'put',
    url: `${API_URL}/vendor_services/${idx}/mark_complete`
  });
}

/** Admin: mark assignment complete for payout (creates credit, shows in Balance Due). */
export function adminMarkCompleteVendorService(idx) {
  return axios({
    method: 'put',
    url: `${API_URL}/vendor_services/${idx}/admin_mark_complete`
  });
}

// Backward-compat aliases
export const getPartnerServices = getVendorServices;
export const getPartnerServiceDetails = getVendorServiceDetails;
export const set_package_remarks = setPackageRemarks;
